import React, { useContext } from 'react';
import { MDForm } from '../metadata/MDForm';
import { ProductInfoContext } from '../data/ApplicationDataSource';
import { ModelContext } from '../metadata/ModelSource';

export function LocationsForm({ children, content, ...props }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);

  return (
    <MDForm
      model={applicationModel}
      productSetupContext={productSetup.productAttributes}
      presentationMetadata={content}
      extendedAttributes={ApplicationExtendedAttributes}
    >
      {React.cloneElement(children, { ...props })}
    </MDForm>
  );
}

export const ApplicationExtendedAttributes = {
  EffectiveDt: {
    label: 'Coverage start date',
    mapping: 'basicPolicy.effectiveDt',
    dateType: 'Date',
    requiredInd: true
  },

  ExistCardId: {
    label: 'Exist Payment Id',
    mapping: 'basicPolicy.electronicPaymentSource.existCardId',
    requiredInd: true
  },

  PaymentMethod: {
    mapping: 'basicPolicy.electronicPaymentSource.methodCd',
    requiredInd: true,
    // dataType: 'Boolean',
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "ExistCardId",
            operator: "Equals",
            value: "NewCard"
          }],
      }
    ]
  },

  PaymentPlan: {
    mapping: 'basicPolicy.payPlanCd',
    requiredInd: true
  },

  CreditCardNumber: {
    mapping: 'basicPolicy.electronicPaymentSource.creditCardNumber',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "CC"
          }],
      }
    ]
  },

  CustomerPaymentProfileId: {
    mapping: 'basicPolicy.electronicPaymentSource.customerPaymentProfileId'
  },

  CustomerProfileId: {
    mapping: 'basicPolicy.electronicPaymentSource.customerProfileId'
  },

  DownPayment: {
    mapping: 'transactionInfo.paymentAmt',
    dataType: 'String',
    requiredInd: true
  },

  DayToWithdraw: {
    mapping: 'basicPolicy.paymentDay',
    dataType: 'String',
    requiredInd: true
  },

  BankAccountType: {
    label: 'Bank Account Type',
    mapping: 'basicPolicy.electronicPaymentSource.achBankAccountTypeCd',
    dataType: 'Select',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "ACH"
          }],
      }
    ]
  },

  BankName: {
    label: 'Bank Name',
    mapping: 'basicPolicy.electronicPaymentSource.achBankName',
    dataType: 'String',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "ACH"
          }],
      }
    ]
  },

  AccountNumber: {
    label: 'Account Number',
    mapping: 'basicPolicy.electronicPaymentSource.achBankAccountNumber',
    dataType: 'String',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "ACH"
          }],
      }
    ]
  },

  AccountType: {
    mapping: 'basicPolicy.electronicPaymentSource.achStandardEntryClassCd',
    dataType: 'Select',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "ACH"
          }],
      }
    ]
  },

  RoutingNumber: {
    label: 'Routing Number',
    mapping: 'basicPolicy.electronicPaymentSource.achRoutingNumber',
    dataType: 'String',
    requiredInd: true,
    attributeRelationships: [
      {
        typeCd: "ApplicableIf",
        attributeConditions: [
          {
            attributeId: "PaymentMethod",
            operator: "Equals",
            value: "ACH"
          }],
      }
    ]
  },

  InterestType: {
    label: 'Interest Type',
    dataType: 'Select',
    requiredInd: true,
    mapping: 'interestTypeCd',
  },

  AIName: {
    label: 'Name',
    dataType: 'String',
    requiredInd: true,
    mapping: 'interestName',
  },

  'AIMailingAddr': {
    label: 'Address',
    dataType: 'String',
    requiredInd: true,
    mapping: 'partyInfo.addresses{addrTypeCd.AIMailingAddr}',
     },

  HasInterestIn: {
    label: 'Has an interest in',
    mapping: 'linkReferences',
    requiredInd: false
  },

  AIMailToName: {
    label: 'Mail to Name',
    dataType: 'String',
    mapping: 'partyInfo.nameInfo.indexName'
  },

  "InsuredName.CommercialName": {
    "dataType": "String",
    "label": "Commerical Name",
    "requiredInd": true,
    "onConstraintViolation": "Error",
    "constraintViolationMessage": "Commercial Name is required",
    "mapping": "insured.partyInfo{partyTypeCd:InsuredParty}.nameInfo.commercialName",

    "attributeRelationships": [
      {
        "typeCd": "ApplicableIf",
        "attributeConditions": [
          {
            "typeCd": "Or",
            "attributeCondition": [
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Joint"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Estate"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Business"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Partnership"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Corporation"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Limited Liability Company"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Association"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Not for Profit Organization"
              },
              {
                "attributeId": "Insured.EntityTypeCd",
                "operator": "Equals",
                "value": "Subchapter S Corporation"
              }
            ]
          }
        ]
      },
      {
        "typeCd": "Derived",
        "attributeDerivations": [
          {
            "attributeId": "Insured.Surname",
            "operator": "concat",
            "value": ", "
          },
          {
            "attributeId": "Insured.GivenName",
            "operator": "concat"
          }
        ]
      }
    ]
  },
};


